export class Weight {
    public get kilograms(): number {
        return this.grams / 1000;
    }

    constructor(public grams: number) {}

    public static fromGrams(grams: number): Weight {
        return new Weight(grams);
    }

    public static fromKilograms(kilograms: number): Weight {
        return new Weight(kilograms * 1000);
    }
}
